export function isUwp() {
    return (window.navigator.userAgent.toLowerCase().indexOf('msapphost/') > -1 &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !!window.Windows);
}
//# sourceMappingURL=isUwp.js.map